import { render, staticRenderFns } from "./Aziende.vue?vue&type=template&id=187dd08a&scoped=true&"
import script from "./Aziende.vue?vue&type=script&lang=js&"
export * from "./Aziende.vue?vue&type=script&lang=js&"
import style0 from "./Aziende.vue?vue&type=style&index=0&id=187dd08a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187dd08a",
  null
  
)

export default component.exports